import { axiosInstance as axios } from '../../boot/axios'
import { axiosInstance as axiosAssembly } from '../../boot/axios-assembly'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    ClosureStatusList({ rootGetters }) {
      return axios
        .get('CaseCheckProcess/ClosureStatusList')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    OemClosureList({ rootGetters }, request) {
      return axios
        .post('CaseCheckProcess/OemClosureList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    OemCaseData({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/OemCaseData', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateOemCase({ rootGetters }, request) {
      return axios
        .put('CaseCheckProcess/UpdateOemCase', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    OemCaseDone({ rootGetters }, request) {
      return axios
        .put('CaseCheckProcess/OemCaseDone', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    OemAutoCabinetNo({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/OemAutoCabinetNo', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // QuickClosureList({ rootGetters }, request) {
    //   return axios
    //     .post('CaseCheckProcess/QuickClosureList', {
    //       ...request
    //     })
    //     .then((response) => {
    //       if (response.data.Values.ReqInt === 0) {
    //         return Promise.resolve(response.data.Values)
    //       } else {
    //         return Promise.reject('發生錯誤')
    //       }
    //     })
    //     .catch((error) => {
    //       return Promise.reject(error)
    //     })
    // },
    // QuickCaseData({ rootGetters }, request) {
    //   return axios
    //     .post('CaseCheckProcess/QuickCaseData', {
    //       ...request
    //     })
    //     .then((response) => {
    //       if (response.data.Values.ReqInt === 0) {
    //         return Promise.resolve(response.data.Values)
    //       } else {
    //         return Promise.reject('發生錯誤')
    //       }
    //     })
    //     .catch((error) => {
    //       return Promise.reject(error)
    //     })
    // },
    // UpdateQuickCase({ rootGetters }, request) {
    //   return axios
    //     .put('CaseCheckProcess/UpdateQuickCase', { ...request })
    //     .then((response) => {
    //       if (response.data.Values.ReqInt === 0) {
    //         return Promise.resolve(response.data.Values)
    //       } else {
    //         return Promise.reject(response.data.Values.Message)
    //       }
    //     })
    //     .catch((error) => {
    //       return Promise.reject(error)
    //     })
    // },
    // QuickCaseDone({ rootGetters }, request) {
    //   return axios
    //     .put('CaseCheckProcess/QuickCaseDone', null, { params: request })
    //     .then((response) => {
    //       if (response.data.Values.ReqInt === 0) {
    //         return Promise.resolve(response.data.Values)
    //       } else {
    //         return Promise.reject('發生錯誤')
    //       }
    //     })
    //     .catch((error) => {
    //       return Promise.reject(error)
    //     })
    // },
    QuickAutoCabinetNo({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/QuickAutoCabinetNo', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    GetRewardSet({ rootGetters }) {
      return axios
        .get('CaseCheckProcess/GetRewardSet')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    SaveRewardSet({ rootGetters }, request) {
      return axios
        .post('CaseCheckProcess/SaveRewardSet', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CheckProcessStatusList({ rootGetters }) {
      return axios
        .get('CaseCheckProcess/CheckProcessStatusList')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetDriverList({ rootGetters }) {
      return axios
        .get('CaseCheckProcess/GetDriverList')
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateAssemblyDriver({ rootGetters }, request) {
      return axios
        .put('CaseCheckProcess/UpdateAssemblyDriver', request)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetRewardCheckList({ rootGetters }, request) {
      return axios
        .post('CaseCheckProcess/GetRewardCheckList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddRewardCheck({ rootGetters }, request) {
      return axios
        .post('CaseCheckProcess/AddRewardCheck', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -2) {
            // 結帳單號重複，無法新增
            return Promise.reject(response.data.Values.errorInfo)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateRewardCheck({ rootGetters }, request) {
      return axios
        .put('CaseCheckProcess/UpdateRewardCheck', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DelRewardCheck({ rootGetters }, request) {
      return axios
        .delete('CaseCheckProcess/DelRewardCheck', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DoneRewardCheck({ rootGetters }, request) {
      return axios
        .post('CaseCheckProcess/DoneRewardCheck', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetRewardCheckDetail({ rootGetters }, request) {
      return axios
        .post('CaseCheckProcess/GetRewardCheckDetail', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    ImportRewardCaseAuto({ rootGetters }, request) {
      return axios
        .post('CaseCheckProcess/ImportRewardCaseAuto', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetRewardCase({ rootGetters }, request) {
      return axios
        .post('CaseCheckProcess/GetRewardCase', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    SaveRewardCase({ rootGetters }, request) {
      return axios
        .post('CaseCheckProcess/SaveRewardCase', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DelRewardCase({ rootGetters }, request) {
      return axios
        .delete('CaseCheckProcess/DelRewardCase', { data: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    CheckStatistics({ rootGetters }, request) {
      return axios
        .post('CaseCheckProcess/CheckStatistics', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    // 代工獎金
    GetOemRewardSales({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/GetOemRewardSales', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetOemRewardBackendSales({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/GetOemRewardBackendSales', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetOemRewardDraw({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/GetOemRewardDraw', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    // 快客獎金
    GetQuickRewardSales({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/GetQuickRewardSales', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetQuickRewardBackendSales({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/GetQuickRewardBackendSales', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    // 司機獎金
    GetDriverRewardMajor({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/GetDriverRewardMajor', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetDriverRewardMinor({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/GetDriverRewardMinor', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    // 師傅獎金
    GetMasterRewardMajor({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/GetMasterRewardMajor', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetMasterRewardMinor({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/GetMasterRewardMinor', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    //未认领訂單列表
    ManufacturerOrderListInAccount({ rootGetters }, request) {
      return axiosAssembly
        .post('ManufacturerOrderListInAccount', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    BindManufacturerOrderByQuick({ rootGetters }, request) {
      return axiosAssembly
        .post('BindManufacturerOrderByQuick', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    BindManufacturerOrderByOem({ rootGetters }, request) {
      return axiosAssembly
        .post('BindManufacturerOrderByOem', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    SetManufacturerOrderByQuickAndOem({ rootGetters }, request) {
      return axiosAssembly
        .post('SetManufacturerOrderByQuickAndOem', { ...request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    //獎金明細匯出Excel
    RewardReportExcel({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/RewardReportExcel', {
          params: request,
          responseType: 'blob'
        })
        .then((response) => {
          if (response.status === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 案件是否可以申請結案
    IsCaseAllowClosureApply({ rootGetters }, request) {
      return axios
        .get('CaseCheckProcess/IsCaseAllowClosureApply', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
  }
}
